import React, { FC, useMemo, useCallback, memo } from 'react';
import { useLazyQuery } from '@apollo/client';
import _map from 'lodash/map';
import _filter from 'lodash/filter';
import _sortBy from 'lodash/sortBy';
import FormikSelectableSearchDropdown from '@minecraft.formik-selectable-search-dropdown';
import ErrorMessage from '@minecraft.error-message';
import { QUERY_CONFLICTS } from '../../FilterBasic/FilterBasicCollection/FilterBasicCollectionGraphQL';
import { FilterData } from '../../shared/types';
import { generateSelectOptionsBasedOnField } from '../../shared/utils';
import { Label, StyledFormikSelectableSearchDropdown } from '../../shared/styles';

type Props = FilterData;

const Conflicts: FC<Props> = ({ name, label }) => {
  const [getConflicts, { data, loading, error }] = useLazyQuery(QUERY_CONFLICTS);

  const handleConflictsFetch = useCallback((): void => {
    if (!data) {
      getConflicts();
    }
  }, [data]);

  const conflictsOptions = useMemo(() => {
    return generateSelectOptionsBasedOnField(
      _sortBy(
        _filter(data?.conflicts, (conflict) => conflict.enabled),
        'sortOrder'
      ),
      'name'
    );
  }, [data?.conflicts]);

  if (error) return <ErrorMessage error={error} />;

  return (
    <>
      <Label>{label}</Label>
      <StyledFormikSelectableSearchDropdown
        saveAsOption
        name={name}
        isLoading={loading}
        onOptionsFetch={handleConflictsFetch}
      >
        {_map(conflictsOptions, (conflict) => (
          <FormikSelectableSearchDropdown.Option key={conflict.value} label={conflict.label} value={conflict.value} />
        ))}
      </StyledFormikSelectableSearchDropdown>
    </>
  );
};

export default memo(Conflicts);
